<template>
  <el-dialog :visible.sync="visible" width="650px" :show-close="false" :close-on-click-modal="false"
    custom-class="batch-add-dialog" @close="closeDialog">
    <div class="dialog-header">
      <span class="dialog-title">{{ $t('batchAddParkingSpace.title') }}</span>
      <i class="el-icon-close dialog-close" @click="visible = false"></i>
    </div>

    <div class="dialog-body">
      <div class="form-row">
        <div class="form-label required">
          <span class="required-mark">*</span>
          <span>小区</span>
          <span class="colon">:</span>
        </div>
        <div class="form-control">
          <el-select v-model="form.communityId" placeholder="请选择" class="form-select" @change="handleCommunityChange">
            <el-option v-for="item in communities" :key="item.communityId" :label="item.name"
              :value="item.communityId"></el-option>
          </el-select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label">
          <span>编号前缀</span>
          <span class="colon">:</span>
        </div>
        <div class="form-control">
          <el-input v-model="form.preNum" :placeholder="$t('batchAddParkingSpace.prefixNumPlaceholder')" class="form-input"></el-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label required">
          <span class="required-mark">*</span>
          <span>开始编号</span>
          <span class="colon">:</span>
        </div>
        <div class="form-control">
          <el-input v-model="form.startNum" type="number" placeholder="请输入" class="form-input"></el-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label required">
          <span class="required-mark">*</span>
          <span>结束编号</span>
          <span class="colon">:</span>
        </div>
        <div class="form-control">
          <el-input v-model="form.endNum" type="number" placeholder="请输入" class="form-input"></el-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label required">
          <span class="required-mark">*</span>
          <span>停车场</span>
          <span class="colon">:</span>
        </div>
        <div class="form-control">
          <el-select v-model="form.paId" placeholder="请选择" class="form-select">
            <el-option v-for="item in parkingAreas" :key="item.paId" :label="item.num" :value="item.paId"></el-option>
          </el-select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label required">
          <span class="required-mark">*</span>
          <span>车位类型</span>
          <span class="colon">:</span>
        </div>
        <div class="form-control">
          <el-select v-model="form.parkingType" placeholder="请选择" class="form-select">
            <template v-for="(item,index) in parkingTypes">
              <el-option :label="item.name" :key="index" :value="item.statusCd"
                v-if="item.statusCd != '2'"></el-option>
            </template>
          </el-select>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <el-button class="cancel-btn" @click="visible = false">取消</el-button>
      <el-button class="confirm-btn" @click="batchSaveParkingSpace" :loading="saving">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { batchSaveParkingSpace } from '@/api/car/listParkingSpaceApi'
import { listParkingAreas } from '@/api/car/listParkingSpaceApi'
import { getDict } from '@/api/community/communityApi'
import { getEffectiveCommunityId } from '@/api/community/communityApi'
import { listCommunitys } from '@/api/community/communityManageApi'

export default {
  name: 'BatchAddParkingSpace',
  data() {
    return {
      visible: false,
      saving: false,
      form: {
        preNum: '',
        startNum: '',
        endNum: '',
        paId: '',
        parkingType: '1',
        area: '1',
        communityId: getEffectiveCommunityId()
      },
      parkingTypes: [],
      parkingAreas: [],
      communities: []
    }
  },
  methods: {
    open() {
      this.visible = true
      this.loadParkingTypes()
      this.loadParkingAreas()
      this.loadCommunities()
    },

    async loadCommunities() {
      try {
        const params = {
          page: 1,
          row: 1000
        }
        const res = await listCommunitys(params)
        this.communities = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        console.error('load communities error:', error)
      }
    },

    async loadParkingTypes() {
      try {
        const data = await getDict('parking_space', 'parking_type')
        this.parkingTypes = data.filter(item => item.statusCd !== '4')
      } catch (error) {
        this.$message.error(this.$t('common.loadDictError'))
      }
    },

    async loadParkingAreas() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: getEffectiveCommunityId(this.form.communityId)
        }
        const res = await listParkingAreas(params)
        this.parkingAreas = res.parkingAreas
      } catch (error) {
        this.$message.error(this.$t('common.loadError'))
      }
    },

    handleCommunityChange() {
      this.form.paId = ''
      this.loadParkingAreas()
    },

    async batchSaveParkingSpace() {
      if (!this.form.communityId) {
        this.$message.error('请选择小区')
        return
      }
      if (!this.form.startNum) {
        this.$message.error('请输入开始编号')
        return
      }
      if (!this.form.endNum) {
        this.$message.error('请输入结束编号')
        return
      }
      if (!this.form.paId) {
        this.$message.error('请选择停车场')
        return
      }
      if (!this.form.parkingType) {
        this.$message.error('请选择车位类型')
        return
      }
      if (parseInt(this.form.endNum) < parseInt(this.form.startNum)) {
        this.$message.error(this.$t('batchAddParkingSpace.endNumPlaceholder'))
        return
      }

      try {
        this.saving = true
        const res = await batchSaveParkingSpace(this.form)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$emit('success')
          this.visible = false
        } else {
          this.$message.error(res.msg || this.$t('common.saveError'))
        }
      } catch (error) {
        console.error('save failed:', error)
        this.$message.error(this.$t('common.saveError'))
      } finally {
        this.saving = false
      }
    },

    closeDialog() {
      this.form = {
        preNum: '',
        startNum: '',
        endNum: '',
        paId: '',
        parkingType: '1',
        area: '1',
        communityId: getEffectiveCommunityId()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .batch-add-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #EBF2FA;
    border-bottom: 1px solid #DCE6F5;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .dialog-title {
      font-size: 16px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 600;
      color: #1D2129;
    }

    .dialog-close {
      font-size: 16px;
      color: #8C9BB4;
      cursor: pointer;

      &:hover {
        color: #1D2129;
      }
    }
  }

  .dialog-body {
    padding: 24px;

    .form-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .form-label {
        width: 86px;
        text-align: right;
        padding-top: 9px;
        flex-shrink: 0;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        color: #1D2129;

        .required-mark {
          color: #FB2C36;
          margin-right: 2px;
        }

        .colon {
          color: #000000;
          margin-left: 2px;
        }
      }

      .form-control {
        flex: 1;
        margin-left: 12px;

        .form-input,
        .form-select {
          width: 100%;

          ::v-deep .el-input__inner {
            border-radius: 10px;
            border: 1px solid #DCE6F5;
            background: #FFFFFF;
            font-family: 'Inter', 'PingFang SC', sans-serif;
            font-size: 14px;
            color: #1D2129;
            height: 38px;
            line-height: 38px;

            &::placeholder {
              color: #8C9BB4;
            }
          }
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 0 24px 28px;

    .cancel-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #0E76FF;
      background: #FFFFFF;
      color: #0E76FF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #E8F3FF;
      }
    }

    .confirm-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: none;
      background: #0E76FF;
      color: #FFFFFF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #1C99FF;
      }
    }
  }
</style>
